import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../../core/shared/object/mvs-object-base/object-base.component";

// NOT_IN_USE
@Component({
    selector: 'as-appointment-booking-object-component',
    templateUrl: 'appointment-booking-object.component.html',
    standalone: false
})
export class AppointmentBookingObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {


    /**
     * On Object Change.
     */
    onObjectChanged() {

    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}
